import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'gatsby'
import CollapseButton from './CollapseButton'
import styles from './swagger-api.module.css'

export default function Xerrors({ x_errors, title }) {
  const [isOpen, setIsOpen] = useState(true)

  if (!x_errors || x_errors.length === 0) {
    return null
  }
  return (
    <div className="dax-more-error" id="errors" data-cy="errors">
      <div className={styles.attributesHeading}>
        <h3 className="dx-anchor">
          <Link to="#errors" aria-hidden="true" />
          Error messages
        </h3>
        <CollapseButton onClick={() => setIsOpen(!isOpen)} isOpen={isOpen} />
      </div>
      {isOpen && (
        <>
          <p>
            In addition to the common{' '}
            <Link to="/api/rest/responses/#http-status-codes">
              HTTP status codes
            </Link>{' '}
            that the REST APIs return, the {title} API can return the following
            errors.
          </p>

          <ul className="dax-messages" data-cy="errors-list">
            {x_errors.map((error, index) => {
              return (
                <li id={`error-${error.name}`} key={index}>
                  <h4 className="dx-anchor">
                    <Link
                      className="dx-anchor__icon"
                      to={`#error-${error.name}`}
                      aria-hidden="true"
                    />
                    <code>{error.name}</code>
                  </h4>
                  <ReactMarkdown source={error.message} escapeHtml={false} />
                  {error.description && (
                    <ReactMarkdown
                      source={error.description}
                      escapeHtml={false}
                    />
                  )}
                </li>
              )
            })}
          </ul>
        </>
      )}
    </div>
  )
}
